// extracted by mini-css-extract-plugin
module.exports = {"membership-regulations":"MembershipRegulations_membership-regulations__dzgyx"};